import { Inject, Injectable } from '@angular/core';
import { CommandHandlerFor, Http, L10n } from '@skylab-angular-shared/core';
import { DocumentDownloadFileCommand, DocumentDownloadFileCommandHandlerBase, DocumentDownloadFileCommandResult, DocumentDownloadFileMultiCommand, DocumentDownloadFileMultiCommandHandlerBase, DocumentDownloadFileMultiCommandResult } from '@skylab-shared/business';
import { HttpService, L10nBase } from '@skylab-shared/core';

@CommandHandlerFor(DocumentDownloadFileCommand)
@Injectable({ providedIn: 'root'})
export class DocumentDownloadFileCommandHandler {
    private commandHandler: DocumentDownloadFileCommandHandlerBase;

    public constructor(
        @Inject(Http) http: HttpService,
        @Inject(L10n) l10n: L10nBase
    ) {
        this.commandHandler = new DocumentDownloadFileCommandHandlerBase(http, l10n);
    }

    public async handleAsync(params: DocumentDownloadFileCommand): Promise<DocumentDownloadFileCommandResult> {
        return await this.commandHandler.handleAsync(params);
    }
}

@CommandHandlerFor(DocumentDownloadFileMultiCommand)
@Injectable({ providedIn: 'root'})
export class DocumentDownloadFileMultiCommandHandler {
    private commandHandler: DocumentDownloadFileMultiCommandHandlerBase;

    public constructor(
        @Inject(Http) http: HttpService
    ) {
        this.commandHandler = new DocumentDownloadFileMultiCommandHandlerBase(http);
    }

    public async handleAsync(params: DocumentDownloadFileMultiCommand): Promise<DocumentDownloadFileMultiCommandResult> {
        return await this.commandHandler.handleAsync(params);
    }
}
